import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'

import languageManager from '../../../../services/languageManager'

import { Form, Input, InputNumber, Select, Switch, Divider } from 'antd'
import { CheckOutlined, CloseOutlined } from '@ant-design/icons'

const ProductReducedForm = (props) => {
    const [layout, setLayout] = useState(props.layout)
    // const [customerId, setCustomerId] = useState(props.customerId)
    const [values, setValues] = useState(props.values)

    const [form] = Form.useForm()
    const { Option } = Select

    useEffect(() => {
        console.log(props)
        // setCustomerId(props.customerId)
        setValues(props.values)
        if (_.isEmpty(props.values)) {
            form.resetFields()
        } else {
            form.setFieldsValue(props.values)
        }
    }, [props.values])

    const submitForm = (values) => {
        // values.customer_id = customerId
        props.submitForm(values)
    }

    return (
        <Form
            form={form}
            {...layout}
            id="CreateProductReducedForm"
            onFinish={submitForm}
        >
            <Form.Item
                label="Nome prodotto"
                name="title"
                rules={[{ required: true, message: 'Inserisci un nome identificativo per il prodotto' }]}
            >
                <Input />
            </Form.Item>
            <Divider />
            <Form.Item
                label="MPN"
                name="mpn"
                rules={[{ required: true, message: 'Inserisci il codice MPN' }]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                label="ASIN"
                name="asin"
            >
                <Input />
            </Form.Item>
            <Form.Item name="id" noStyle><Input type="text" type="hidden" /></Form.Item>
        </Form>
    )
}

const mapStateToProps = state => {
    return {
        commonState: state.commonState,
    }
}

export default connect(mapStateToProps)(ProductReducedForm)